import { useState as w, useRef as m, useEffect as o, useMemo as p } from "react";
import { getHoopsViewerApi as V } from "./HoopsViewer.api.mjs";
const W = (r, n, t) => {
  const [e, u] = w(), i = m(e || null);
  o(() => {
    i.current = e || null;
  }, [e]), o(() => {
    if (i.current && (i.current = null), !t)
      return;
    const s = t.id;
    if (!s)
      return;
    const f = new r.WebViewer({ containerId: s, ...n });
    u(f);
  }, [r.WebViewer, n, t]);
  const c = p(() => {
    if (r && e)
      return V({ viewer: e, bundle: r });
  }, [r, e]);
  return { viewer: e, API: c };
};
export {
  W as useWebViewer
};
//# sourceMappingURL=HoopsViewer.hooks.mjs.map
